module.exports = __webpack_public_path__ + "img/8.332a0675.jpg";